module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"deleteNote":"Are you sure you want to permanently delete this note?","hasComment":"There aren\u0027t any comments yet","date":"Date","author":"Author","activity":"Activity","placeholder":"Leave comment"}}')
  delete Component.options._Ctor
}
